// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__duC5I","input":"styles_input__7yNsm","btn":"styles_btn__4ifCO","btn_delete":"styles_btn_delete__uvhcO","btn_edit":"styles_btn_edit__gXgkK"};